import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const profileCardAvatar = css`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
`;

export const profileCardAvatarNoBadge = css`
  display: block;
`;

export const buttonContainer = css`
  justify-content: flex-end;

  @media (max-width: ${dimensions.phone}) {
    flex-direction: column;
    margin-right: 0;
    align-items: center;
  }
`;

export const headerStyles = css`
  display: flex;
  margin-right: 2.5rem;
  justify-content: space-between;
  align-items: center;
`;

export const title = css`
  &&& {
    margin-bottom: 0;
  }
`;

export const leftButton = css`
  margin-right: 1rem;

  @media (max-width: ${dimensions.phone}) {
    margin-right: 0;
    margin-bottom: 1.75rem;
  }
`;

export const imgContainer = css`
  margin-right: 2.5rem;
  max-width: 100%;
`;

export const image = css`
  display: flex;
  justify-content: center;
`;

export const children = css`
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  @media screen and (max-width: ${dimensions.tablet}) {
    width: 100%;
  }
`;
